import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const GraphicDesign = () => {

  const projects = [
    { title: "Brand Identity Design", desc: "Complete branding system for startups.", link: "#" },
    { title: "Social Media Creatives", desc: "High-converting marketing visuals.", link: "#" },
  ];

  const testimonials = [
    { name: "Hina Ali", role: "Brand Owner", feedback: "Stunning visuals and strong branding!" },
    { name: "Zara Khan", role: "Marketing Lead", feedback: "Creative and highly professional designs." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-pink-500/30 blur-[120px] rounded-full top-20 left-1/2 -translate-x-1/2"></div>

        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-extrabold">
            Creative <span className="text-pink-400">Graphic Design</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto">
            Designs that don’t just look good — they communicate, convert, and elevate your brand.
          </p>

          <div className="mt-10 flex gap-4 justify-center flex-wrap">
            <Link to="/contact" className="px-8 py-4 bg-pink-500 rounded-full">
              Start Design
            </Link>

            <a href="https://calendly.com/thelogicwaves/30min"
              className="px-8 py-4 border rounded-full">
              Book a Call
            </a>
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section className="py-24 text-center max-w-5xl mx-auto px-6">
        <h2 className="text-4xl font-bold mb-6">Beyond Just Visuals</h2>
        <p className="text-gray-400">
          We create meaningful visual experiences that connect brands with people.
        </p>
      </section>

      {/* WHAT WE BUILD */}
      <section className="py-24 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
        {["Logo Design","Brand Identity","Social Media Design","UI Graphics","Marketing Creatives","Print Design"].map((item,i)=>(
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10">
            <h3 className="text-pink-400">{item}</h3>
          </div>
        ))}
      </section>

      {/* PROCESS */}
      <section className="py-24 bg-[#0b1a35] text-center">
        <h2 className="text-4xl font-bold mb-12">Our Creative Process</h2>
        <div className="grid md:grid-cols-4 gap-8">
          {["Research","Concept","Design","Deliver"].map((step,i)=>(
            <div key={i}>
              <div className="text-pink-400 text-2xl font-bold">{i+1}</div>
              <p>{step}</p>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      {/* CTA */}
      <section className="py-28 text-center bg-gradient-to-r from-pink-500 to-purple-500">
        <h2 className="text-4xl font-bold mb-6">Let’s Create Something Beautiful 🎨</h2>
        <Link to="/contact" className="bg-black px-6 py-3 rounded">
          Contact Us
        </Link>
      </section>

    </div>
  );
};

export default GraphicDesign;